import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAssistantOptional } from '@/contexts/AssistantContext';
import {
  buildModuleContext,
  type NavModule,
  type NavTab,
} from '@/utils/moduleNavContext';

/** Registers the current module + active sub-nav page as the assistant's module context. */
export function useRegisterModuleContext(
  currentModule: NavModule | null | undefined,
  subNavTabs: NavTab[],
) {
  const assistant = useAssistantOptional();
  const register = assistant?.registerModuleContext;
  const { pathname, search } = useLocation();

  const ctx = useMemo(
    () => buildModuleContext(currentModule, subNavTabs, { pathname, search }),
    [currentModule, subNavTabs, pathname, search],
  );
  const id = ctx?.id;
  const routeUrl = ctx?.routeUrl;

  useEffect(() => {
    if (!register) return;
    register(ctx);
    return () => register(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register, id, routeUrl]);
}
